import { useContext, useEffect } from "react";
import { Box, CircularProgress, Typography } from '@mui/material';
import { App_sesion_token_key, AxiosInstance, DialogType } from "../utils/constants";
import { useNavigate } from "react-router-dom";
import { AppERoutesIndex } from "../route/app-routes";
import { ActionTypes, AppContext } from "../store/AppStore";
import { CustomLogoApp } from "../components/logo";

export const Main = ()=>{

    const navigate = useNavigate();
    const {dispatch} = useContext( AppContext );

    useEffect(()=>{
        let token = localStorage.getItem(App_sesion_token_key);
       
        if (!token){
          
            setTimeout(()=>  navigate(AppERoutesIndex.login,{replace:true}),1500);

        }else{
            LoadUserData();
           
        }
    },[]);

    const LoadUserData = async()=>{

        try{
  
          let {data:{value}} = await AxiosInstance.get("sesion/obtener-datos-usuario");
          
          if ( Object.keys(value.perfil).length > 0 ){
            dispatch({
              type:ActionTypes.setProfileUsers,
              data: {...value}
            });
             setTimeout(()=>{
                if ( value.firma ){
                    navigate(AppERoutesIndex.plataformaBase);
                    window.location.reload();
                  }else{
                     navigate(AppERoutesIndex.generarFirma,{replace:true});
                     window.location.reload();
                  }
             },1500);
            
          
         } 
  
        }catch(e){
          console.log(e.message);
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error en los servicios",
                message:"Ha ocurrido un error al tratar de enviar los datos al servidor",
                type:DialogType.peligro,
                isVisible:true
            }
        });
  
        }
       
       
     
     }


    return (
        <Box
          sx={{
            minHeight: '100dvh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            px: 3,
          }}
        >
             <CustomLogoApp height={88} alt="Acércate" />
             <CircularProgress color="inherit" sx={{ mt: 3 }} />
             <Typography variant="caption" sx={{ mt: 1.5 }}  >Cargando Acércate</Typography>
        </Box>
    )

}
